var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "file",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 13,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.873 4.8C14.839 4.76364 14.8221 4.72727 14.8051 4.69091C14.7881 4.65454 14.7711 4.61818 14.7372 4.58182L10.6645 0.218182C10.5966 0.145455 10.5287 0.0727273 10.4608 0.0727273C10.393 0 10.2572 0 10.1893 0H4.75902C3.60508 0 2.72266 0.945455 2.72266 2.18182V13.8182C2.72266 15.0545 3.60508 16 4.75902 16H12.9045C14.0584 16 14.9408 15.0545 14.9408 13.8182V5.09091C14.9408 5.01818 14.9408 4.87273 14.873 4.8ZM10.8683 2.4725L12.6332 4.36341H10.8683V2.4725ZM4.75881 14.5454H12.9043C13.3115 14.5454 13.5831 14.2545 13.5831 13.8181V5.8181H10.1891C9.78184 5.8181 9.51033 5.52719 9.51033 5.09083V1.45447H4.75881C4.35154 1.45447 4.08003 1.74538 4.08003 2.18174V13.8181C4.08003 14.2545 4.35154 14.5454 4.75881 14.5454Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.242188,
    y: -0.727539,
    width: 16.2909,
    height: 17.4545
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.0032bd95a9373c4657dbffba36cb5865.svg";
export { ForwardRef as ReactComponent };